module.exports = __webpack_public_path__ + "static/media/Alba soffa divan 210_3 FS tyg Vogue Winter Moss 11 detalj 2024 6.68dec44d.jpg";